<template>
  <v-autocomplete
    :value="value"
    :disabled="$store.state.loadingRequestGeneral"
    :items="$store.state.PrimeryKotelnyh.listEntries"
    :loading="$store.state.loadingRequestGeneral"
    :item-text="entryDisplayName"
    return-object
    class="mb-5"
    dense
    hide-details
    placeholder="Выберите примеры работ"
    outlined
    :menu-props="{ maxHeight: '30vh' }"
    @change="onSelect"
  >
  </v-autocomplete>
</template>

<script>
export default {
  name: "SpecificationInsertingArticle",
  props: {
    value: { type: [Object, null], default: null },
  },
  computed: {
    entryDisplayName() {
      return (item) => item?.name || item?.code || `ID ${item?.id}`;
    },
  },
  methods: {
    onSelect(value) {
      this.$emit("input", value || null);
    },
  },
};
</script>